import ReactMarkdown from 'react-markdown';
import rehypeRaw from 'rehype-raw';
import React from 'react';

interface MARKDOWNINTERFACE {
  content: string;
}

const MARKDOWN = ({ content }: MARKDOWNINTERFACE) => {
  return (
    <ReactMarkdown
      components={{
        p: ({ node, children }) => {
          // Avoid wrapping <p> if it directly contains an <a> element
          const hasLink = node.children.some(child => {
            return (
              typeof child === 'object' &&
              'tagName' in child &&
              child.tagName === 'a'
            );
          });

          if (hasLink) {
            return <>{children}</>; // Don't wrap in <p> if it has an <a>
          }

          return <p>{children}</p>; // Wrap normal content in <p>
        },
        a: ({ node, ...props }) => <a {...props} /> // Custom <a> rendering
      }}
      rehypePlugins={[rehypeRaw]}
    >
      {content}
    </ReactMarkdown>
  );
};

export default MARKDOWN;
